import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function WorkCenter({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Job Work Centers</b>
          </p>
          <p>
            Job work centers allow you to organize your job into stages. This
            API field is an array of objects that represent the sequence of work
            and a reference to the pre-defined work center.
            <pre>
              <code>
                {`
{
  "sequence": integer,
  "workcenter": array of references
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
WorkCenter.propTypes = {
  type: PropTypes.string.isRequired
};
